import { TextboxController } from "./textbox-controller.interface";
import { TextboxComponent } from "../textbox.component";

export class DefaultController implements TextboxController {
    component: TextboxComponent;

    change(): void {
    }

    focus() {
    }

    blur() {
    }

    onInit(): void {
       
    }
}